import moment, { Moment } from 'moment';

export const getDaysRange = (startDateRange: Moment, endDateRange: Moment) => {
  if (startDateRange && endDateRange) {
    return Math.abs(moment(endDateRange).diff(moment(startDateRange), 'days'));
  }
  return undefined;
};
